/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import APPOINT_SUCCESS_PNG from '@/resources/images/billReport/appoint_success.png';
export default {
  data: function data() {
    return {// appointSuccessIMG: APPOINT_SUCCESS_PNG
    };
  },
  created: function created() {}
};